import api from './client';
import { Food } from './types';

export const addFood = async (food: Food) => {
  const response = await api.post('foods/', [food]);
  return response.data;
};

export const getFood = async (): Promise<Food[]> => {
  const response = await api.get('foods/');
  return response.data;
};
